<template>
  <div ref="contractDashpdf" id="contractDashpdf">
    <section class="dashboard">
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      </div>
      <b-card class="mainCardBG" v-if="showDash == true">
        <b-card-text>
          <b-navbar
            class="formCard w-100 d-block"
            style="
              border-radius: 5px !important;
              padding-left: 0px;
              height: auto !important;
            "
            toggleable="lg"
            type="dark"
            variant="primary"
          >
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon
              >Back </b-button
            >`
            <b-row>
              <b-col md="8">
                <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
              </b-col>
              <b-col md="2">
                <b-navbar-brand center
                  ><span v-if="isLoading == false"
                    >{{ totalData }} Entries</span
                  ></b-navbar-brand
                >
              </b-col>
              <b-col md="2">
                <b-navbar-nav class="pull-right mr-auto">
                  <b-nav-form>
                    <b-button @click="filterClear">Clear</b-button>
                    <b-button class="ml-1" variant="outline-info" @click="getPDF">
                      <i class="fa fa-cloud-download" aria-hidden="true"></i>
                    </b-button>
                  </b-nav-form>
                </b-navbar-nav>
              </b-col>
            </b-row>
          </b-navbar>

          <b-card>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Date</label>
                <date-range-picker
                  :opens="openLeft"
                  :always-show-calendars="showCal"
                  v-model="dateRange"
                  :startDate="startDate"
                  :endDate="endDate"
                  :locale-data="locale"
                  @update="getContractList('Normal', '0', '0', '1', '1')"
                ></date-range-picker>
              </b-col>
              <b-col md="3">
                <label>Shipping Line</label>
                <model-list-select
                  :list="$store.getters['common/getAllShippingLineList']"
                  v-model="Filter.slineFilter"
                  option-value="shippingId"
                  option-text="shippingLine"
                  placeholder="Select Shipping Line"
                  :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' ? true : false
                  "
                  @input="getContractList('Normal', '0', '0', '1', '1')"
                ></model-list-select>
              </b-col>

              <b-col md="3">
                <label>POR</label>
                <model-list-select
                  @input="
                    getLocationList($event, 'All', 'finalAllPlaceDataPOR');
                    getContractList('Normal', '0', '0', '1', '1');
                  "
                  @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                  :list="$store.getters['common/getAllPORList']"
                  v-model="Filter.porFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POR"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>POD</label>
                <model-list-select
                  @input="
                    getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
                    getContractList('Normal', '0', '0', '1', '1');
                  "
                  @searchchange="
                    getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
                  "
                  :list="
                    getPortDischargeList.length > 0
                      ? getPortDischargeList
                      : $store.getters['common/getAllPODList']
                  "
                  v-model="Filter.podFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POD"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>POL</label>
                <model-list-select
                  @input="
                    getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                    getContractList('Normal', '0', '0', '1', '1');
                  "
                  @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                  :list="$store.getters['common/getAllPOLList']"
                  v-model="Filter.polFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POL"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>FPOD</label>
                <model-list-select
                  @input="
                    getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                    getContractList('Normal', '0', '0', '1', '1');
                  "
                  @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                  :list="$store.getters['common/getAllLocationDetailsFinalList']"
                  v-model="Filter.fpodFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select Final Port of Discharge"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Container Type</label>
                <model-list-select
                  :list="$store.getters['common/getAllContainerTypeList']"
                  v-model="Filter.containerTypeFilter"
                  option-value="containerTypeId"
                  option-text="containerType"
                  placeholder="Select Container Type"
                  @input="getContractList('Normal', '0', '0', '1', '1')"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Contract No Filter</label>
                <b-form-input
                  type="text"
                  :formatter="capitalizeAll"
                  placeholder="Search Contract No Filter"
                  id="contractFilter"
                  name="contractFilter"
                  autocomplete="off"
                  v-model="Filter.contractFilter"
                  @input="getContractList('Normal', '0', '0', '1', '1')"
                ></b-form-input>
              </b-col>
              <b-col md="3">
                <label>Common Filter</label>
                <b-form-input
                  type="text"
                  :formatter="capitalizeAll"
                  placeholder="Search Common Filter"
                  id="contractFilter"
                  name="commonFilter"
                  autocomplete="off"
                  v-model="Filter.commonFilter"
                  @input="getContractList('Normal', '0', '0', '1', '1')"
                ></b-form-input>
              </b-col>
              <b-col md="3">
                <b-button
                  v-if="getContList.length > 0"
                  :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                  @click="getReports('getContList', 'Export As Excel')"
                  size="sm"
                  variant="warning"
                  style="font-size: 0.675rem"
                >
                  {{ ExcelBtnName }}
                  <b-spinner
                    v-if="ExcelBtnName != 'Export As Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div>
                  <b-pagination
                    limit="25"
                    align="center"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="totalData"
                    @change="onPageChange($event)"
                  ></b-pagination>
                </div>

                <div class="table-responsive tableMain gutr">
                  <b-table
                    show-empty
                    stacked="md"
                    :items="getContList"
                    responsive
                    :fields="contractFields"
                    primary-key="id_email_section"
                    :per-page="pagination.perPage"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    class="position-relative"
                  >
                    <template slot="SN" slot-scope="row0">
                      <span>{{
                        row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                      }}</span>
                    </template>
                    <template slot="contarct_no" slot-scope="row1">
                      <b
                        style="color: blue"
                        @click="goContractDetails(row1.item)"
                        class="showMoreData"
                        ><u>{{ row1.item.contarct_no }}</u></b
                      >
                    </template>
                  </b-table>
                </div>
                <div>
                  <b-pagination
                    limit="25"
                    align="center"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="totalData"
                    @change="onPageChange($event)"
                  ></b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-card-text>
      </b-card>
    </section>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import AccountService from "../../services/AccountService.js";
export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({
          itemCode: "LocationDetailsFinalList",
        })
      );
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({
          itemCode: "PORList",
        })
      );
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
          type: "Normal",
          Territory: "",
        })
      );
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({
          itemCode: "POLList",
        })
      );
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
      this.$store.dispatch("setCurrentRoute", "/contractDash");

      this.getCurrentLastDate();
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getContractList("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {},
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      docURL: URL_BASE_DOC,
      getContList: [],
      totalData: 0,
      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      contractFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "contarct_no",
          mainkey: "contarct_no",
          label: "Contract No",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "contract_start_date",
          mainkey: "contract_start_date",
          label: "Contract Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "territoriesName",
          mainkey: "territoriesName",
          label: "Territory",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "ContractStatus",
          mainkey: "ContractStatus",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "expire_status",
          mainkey: "expire_status",
          label: "Expiry Status",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "containerType",
          mainkey: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "tot_volume_consumed_exact",
          mainkey: "tot_volume_consumed_exact",
          label: "Tot Volume Consumed",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },
        {
          key: "tot_volume_remaining_exact",
          mainkey: "tot_volume_remaining_exact",
          label: "Tot remaining",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
        {
          key: "continer_tues_commitment_val",
          mainkey: "continer_tues_commitment_val",
          label: "Tot. Volume",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
        {
          key: "continer_contract_rate",
          mainkey: "continer_contract_rate",
          label: "Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "J.",
        },
        {
          key: "continer_premium_contract_rate",
          mainkey: "continer_premium_contract_rate",
          label: "Premium Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "contract_remark",
          mainkey: "contract_remark",
          label: "Remarks",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "continer_remark",
          mainkey: "continer_remark",
          label: "Remarks",
          sortable: true,
          sortDirection: "ASC",
          table: "M.",
        },
      ],

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      Filter: {
        slineFilter: this.$sessionsStorage.get("contractSlienDash"),
        porFilter: "",
        podFilter: "",
        polFilter: "",
        fpodFilter: "",
        containerTypeFilter: "",
        contractFilter: "",
        commonFilter: "",
      },
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openLeft: "right",
      showCal: false,
      showDash: true,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },

      isLoading: false,

      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    };
  },
  methods: {
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getContractList("Excell", "0", "0", "1", "1");
    },
    getContractList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getContList = [];
      let payload = {};
      this.isLoading = true;
      payload = {
        itemCode: "getContractDashList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      AccountService.getAllContractList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getContractDashList.length > 0) {
                this.totalData = data.totalRows;
                this.getContList = data.getContractDashList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getContractDashList.length > 0) {
                this.totalData = data.totalRows;
                this.getContList = data.getContractDashList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getContractDashList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getContractList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContractList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContractList("Normal", "0", CURRENT, "2", event);
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              this.getPortDischargeList = result;
            }
          }
        });
        console.log("self[vmodelArray]=>", self);
      }
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };

      this.getPortDischargeList =
        this.$store.getters["common/getAllPODList"].length > 0
          ? this.$store.getters["common/getAllPODList"]
          : [];
    },
    filterClear() {
      this.Filter = {
        slineFilter: this.$sessionsStorage.get("contractSlienDash"),
        porFilter: "",
        podFilter: "",
        polFilter: "",
        fpodFilter: "",
        containerTypeFilter: "",
        contractFilter: "",
        commonFilter: "",
      };
      this.dateSearch.fromDate = "";
      this.dateSearch.toDate = "";
      this.getCurrentLastDate();
    },

    // Added By Priyanshu Singh Start
    download() {
      let windowHeight = window.outerHeight;
      let windowWidth = window.outerWidth;

      let pdf = new jsPDF();

      let canvasElement = document.createElement("canvas");
      canvasElement.width = 4000;
      canvasElement.height = 4000;

      html2canvas(this.$refs.contractDashpdf, {
        canvas: canvasElement,
        width: windowWidth,
        height: windowHeight,
      })
        .then((canvas) => {
          const img = canvas.toDataURL("image/jpeg", 5);
          document.body.appendChild(canvas);
          pdf.addImage(img, "JPEG", 10, 10);
          pdf.save("sample.pdf");

          alert("works");
        })
        .catch((err) => {
          alert("error");
        });
    },
    goBack() {
      window.history.go(-1);
    },

    goContractDetails(contractNo) {
      if (contractNo != "") {
        this.$sessionsStorage.set("contractNoFilterDash", "");
        this.$sessionsStorage.set("contractIDFilterDash", "");
        this.$sessionsStorage.set("contractNoFilterDash", contractNo.contarct_no);
        this.$sessionsStorage.set("contractIDFilterDash", contractNo.cb_id);
        this.$router.push({
          path: "/contractDash/ContractDet/" + contractNo.cb_id,
        });
      }
    },
    getPDF() {
      var HTML_Width = $("#contractDashpdf").width();
      var HTML_Height = $("#contractDashpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#contractDashpdf")[0], { allowTaint: true }).then(function (canvas) {
        canvas.getContext("2d");

        // console.log(canvas.height + "  " + canvas.width);

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }
        var date = new Date();
        var timestamp = date.getTime();

        pdf.save("Contract_DASHBOARD_" + timestamp + ".pdf");
      });
    },
    // Added By Priyanshu Singh End
  },
};
</script>

<style scoped>
.topFiveHeight {
  height: 315px !important;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #ffffff !important;
}
.mainCard {
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 10px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: none !important;
}
.page-header {
  display: flex;
  align-items: center;
  margin: 1.5rem 2rem 1.5rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.topDivCard {
  margin: 1.5rem 2rem 1.5rem;

  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin: 1.5rem 1rem 1.5rem;
  margin-bottom: 0rem !important;
  font-weight: 600 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.col-lg-6 {
  width: 49%;
}
.col-lg-4 {
  width: 32.6%;
}
</style>



// WEBPACK FOOTER //
// contractDashboard.vue?a4874e3c